//#region src/url.ts
const RE_ARTWORK_PATHNAME = /^(?:\/(?<lang>\w+))?\/(?<type>artwork|video)\/(?<id>\d+)(?:-(?<slug>[^/]+)?)?$/i;
function parseArtworkUrl(url) {
	const { pathname } = new URL(url, "https://example.com");
	const match = RE_ARTWORK_PATHNAME.exec(pathname);
	if (match?.groups) return {
		type: match.groups.type,
		id: match.groups.id,
		slug: match.groups.slug
	};
}
const RE_MODEL_PATHNAME = /^(?:\/(?<lang>\w+))?\/model\/(?<id>\d+)(?:-(?<slug>[^/]+)?)?(?:\/(?<versionId>\d+))?$/i;
function parseModelUrl(url) {
	const { pathname } = new URL(url, "https://example.com");
	const match = RE_MODEL_PATHNAME.exec(pathname);
	if (match?.groups) return {
		modelId: match.groups.id,
		modelSlug: match.groups.slug,
		versionId: match.groups.versionId
	};
}
//#endregion
export { parseArtworkUrl, parseModelUrl };
